import { lazy } from 'react'

import AuthUser from './pages/AuthUser'
import ChooseModule from './pages/ChooseModule'
import Profile from './pages/Profile'
import SignIn from './pages/SignIn'

const usersModule = {
  meta: {
    name: 'users',
    path: '/',
    global: true
  },
  routes: [
    {
      name: 'AuthUser',
      path: '/auth',
      component: AuthUser
    },
    {
      name: 'ChooseModule',
      path: '/modules',
      component: ChooseModule,
      meta: {
        isPrivate: true
      }
    },

    {
      name: 'Profile',
      path: '/profile',
      component: Profile,
      meta: {
        isPrivate: true
      }
    },
    {
      name: 'SignIn',
      path: '/',
      exact: true,
      component: SignIn
    },
    {
      name: 'SignUp',
      path: '/signup',
      component: lazy(() => import('./pages/SignUp'))
    },
    {
      name: 'ForgotPassword',
      path: '/forgot-password',
      component: lazy(() => import('./pages/ForgotPassword'))
    },
    {
      name: 'ResetPassword',
      path: '/reset-password',
      component: lazy(() => import('./pages/ResetPassword'))
    },
    {
      name: 'Roles',
      path: '/roles',
      isPrivate: true,
      exact: true,
      component: lazy(() => import('./pages/Roles')),
      meta: {
        isPrivate: true,
        permissions: []
      }
    },
    {
      name: 'Users',
      path: '/users',
      isPrivate: true,
      exact: true,
      component: lazy(() => import('./pages/UnitUsers')),
      meta: {
        isPrivate: true,
        permissions: ['users-unit:list']
      }
    },
    {
      name: 'Forbidden',
      path: '/403',
      isPrivate: true,
      exact: true,
      component: lazy(() => import('./pages/Forbidden')),
      meta: {
        isPrivate: true,
        permissions: []
      }
    }
  ]
}

export default usersModule
